import { VendorMatchScore } from '@/lib/types/job';
import { formatCriterionBreakdown, getScoreColorClass } from '@/lib/matchScoreUtils';
import { Progress } from '@/components/ui/progress';

interface MatchScoreTooltipProps {
  matchScore: VendorMatchScore;
}

export const MatchScoreTooltip = ({ matchScore }: MatchScoreTooltipProps) => {
  console.log('[MatchScoreTooltip] Rendering with score:', matchScore.score, 'details:', matchScore.details);
  const criteria = formatCriterionBreakdown(matchScore);
  console.log('[MatchScoreTooltip] Formatted criteria count:', criteria.length, 'items:', criteria);

  return (
    <div className="space-y-3 min-w-[260px] max-w-[280px]">
      <div className="flex items-center justify-between pb-2 border-b">
        <span className="text-sm font-semibold">Match Score</span>
        <span className={`text-lg font-bold ${getScoreColorClass(matchScore.score)}`}>
          {matchScore.score}%
        </span>
      </div>

      <div className="space-y-3">
        {criteria.map((criterion, index) => (
          <div key={index} className="space-y-1">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-1.5">
                <criterion.icon className="h-3.5 w-3.5 text-muted-foreground" />
                <span className="text-xs font-medium">{criterion.label}</span>
              </div>
              <span className={`text-xs font-semibold ${getScoreColorClass(criterion.score)}`}>
                {criterion.score}%
              </span>
            </div>
            <p className="text-xs text-muted-foreground pl-5">{criterion.detail}</p>
            <Progress value={criterion.score} className="h-1" />
          </div>
        ))}
      </div>

      <div className="pt-2 border-t">
        <p className="text-xs text-muted-foreground italic">
          Score = Average of {matchScore.total_criteria} {matchScore.total_criteria === 1 ? 'criterion' : 'criteria'}
        </p>
      </div>
    </div>
  );
};
